module.exports = __webpack_public_path__ + "img/canopy-gable.b217d0eb.svg";